import { AlpineComponent } from 'alpinejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Navigation = (): AlpineComponent => ({
  timeout: null,
  isNavOpen: false,

  init() {},
  openDialog() {
    if (this.timeout) clearTimeout(this.timeout);
    disableBodyScroll(this.$refs.dialog);
    (this.$refs.dialog as HTMLDialogElement).showModal();
    this.isNavOpen = true;
  },

  closeDialog() {
    enableBodyScroll(this.$refs.dialog);
    this.isNavOpen = false;
    this.timeout = setTimeout(() => {
      (this.$refs.dialog as HTMLDialogElement).close();
    }, 300);
  }
});

export default Navigation;
